import { queryOptions } from '@tanstack/react-query';

import { roleRequestsClient } from './client';
import type { RoleRequestStatus } from './types';

export const ROLE_REQUEST_QUERY_KEYS = {
  list: 'entity-role-requests',
};

export const _getRoleRequests = (entityId?: string | null, status?: RoleRequestStatus) =>
  queryOptions({
    enabled: !!entityId,
    queryKey: [ROLE_REQUEST_QUERY_KEYS.list, entityId, status],
    queryFn: () => roleRequestsClient.list({ status }),
  });
